import PropTypes from 'prop-types'
import React, { useContext, useEffect, useMemo, useState } from 'react'

const initialState = {
  isUpdateAvailable: false,
  updateApp: null,
}

export const ServiceWorkerContext = React.createContext(initialState)

export const ServiceWorkerProvider = ({ children }) => {
  const [isUpdateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing
            if (!newWorker) return
            newWorker.addEventListener('statechange', () => {
              if (
                newWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                setUpdateAvailable(true)
                newWorker.postMessage({ type: 'SKIP_WAITING' })
              }
            })
          })
        })
        .catch(() => {
          // Service worker registration failed — non-fatal
        })
    }
  }, [])

  const value = useMemo(
    () => ({
      isUpdateAvailable,
      updateApp: () => {
        window.location.reload()
      },
    }),
    [isUpdateAvailable]
  )

  return (
    <ServiceWorkerContext.Provider value={value}>
      {children}
    </ServiceWorkerContext.Provider>
  )
}

ServiceWorkerProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export const useServiceWorker = () => {
  const { isUpdateAvailable, updateApp } = useContext(ServiceWorkerContext)

  return {
    isUpdateAvailable,
    updateApp,
  }
}

export default useServiceWorker
